import { render, staticRenderFns } from "./selfpay.vue?vue&type=template&id=2ee35529&scoped=true"
import script from "./selfpay.vue?vue&type=script&lang=js"
export * from "./selfpay.vue?vue&type=script&lang=js"
import style0 from "./selfpay.vue?vue&type=style&index=0&id=2ee35529&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee35529",
  null
  
)

export default component.exports